import { CollectionsToolPanel } from "../CollectionsToolPanel";
import { Button, DataSource, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCollectionsTable extends Layout {
    buttonCallEntry: Button;
    labelCreditLimitHeader: Label;
    labelOpenCreditsHeader: Label;
    labelPaymentsHeader: Label;
    labelPeriodTotalsHeader: Label;
    labelTermsHeader: Label;
    layoutCollectionsToolPanel: CollectionsToolPanel;
    panelCreditLimit: Panel;
    panelCreditLimitValues: Panel;
    panelFooter: Panel;
    panelOpenCredits: Panel;
    panelOpenCreditsValues: Panel;
    panelPayments: Panel;
    panelPaymentsValues: Panel;
    panelPeriodTotals: Panel;
    panelPeriodTotalsValues: Panel;
    panelSecondaryFilters: Panel;
    panelTerms: Panel;
    panelTermsValues: Panel;
    sourceCollections: DataSource;
    sourceCustomerAging: DataSource;
    sourceLastPayment: DataSource;
    tableCollections: Table;
    textboxAvailableCreditLimit: Textbox;
    textboxAveragePayDays: Textbox;
    textboxBillDueDays: Textbox;
    textboxCurrentPeriodTotal: Textbox;
    textboxLastPaymentAmount: Textbox;
    textboxLastPaymentDate: Textbox;
    textboxOpenCreditsTotalBalance: Textbox;
    textboxPeriod1Total: Textbox;
    textboxPeriod2Total: Textbox;
    textboxPeriod3Total: Textbox;
    textboxPeriod4Total: Textbox;
    textboxTotalCreditLimit: Textbox;
    textboxUsedCreditLimit: Textbox;
}
